export const HTTP_STATUS = {
  // 4xx Client Errors
  BAD_REQUEST: 400, // General validation/syntax error
  UNAUTHORIZED: 401, // Session expired / missing token
  FORBIDDEN: 403, // Authenticated but no permission for this action
  NOT_FOUND: 404, // Resource deleted or wrong URL
  METHOD_NOT_ALLOWED: 405, // Calling POST on a GET endpoint
  CONFLICT: 409, // Edit collisions (e.g., "Email already exists")
  UNPROCESSABLE_ENTITY: 422, // Validation errors (Common for Zod/Backend sync)
  TOO_MANY_REQUESTS: 429, // Rate limiting

  // 5xx Server Errors
  INTERNAL_SERVER_ERROR: 500, // The "Something went wrong" catch-all
  BAD_GATEWAY: 502, // Server is down or restarting
  SERVICE_UNAVAILABLE: 503, // Maintenance mode
  GATEWAY_TIMEOUT: 504, // Request took too long

  // 2xx Success
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
} as const

export type HttpStatus = (typeof HTTP_STATUS)[keyof typeof HTTP_STATUS]
